import * as Yup from 'yup';
import { useState } from 'react';
import { useSnackbar } from 'notistack'
import { useNavigate, } from 'react-router-dom';
// form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import { Link, Stack, Alert, IconButton, InputAdornment } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// routes
import { PATH_AUTH } from '../../routes/paths';
// auth
import { useAuthContext } from '../../auth/useAuthContext';
// components
import Iconify from '../../components/iconify';
import FormProvider, { RHFTextField } from '../../components/hook-form';
// hooks
import useIsMountedRef from '../../hooks/useIsMountedRef'

// ----------------------------------------------------------------------

const defaultValues = {
  email: '',
  password: '',
};

export default function AuthLoginForm() {
  const { enqueueSnackbar } = useSnackbar()
  const { login, eventId } = useAuthContext();
  const navigate = useNavigate()
  const isMountedRef = useIsMountedRef()

  const [showPassword, setShowPassword] = useState(false);

  const LoginSchema = Yup.object().shape({
    email: Yup.string().email('Email invalido').required('Campo requerido').trim(),
    password: Yup.string().required('Campo requerido'),
  });

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  });

  const {
    reset,
    setError,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = methods;

  const onSubmit = async (data) => {
    try {
      await login(data.email, data.password)
        .then((data) => {
          if (!data?.is_member) {
            navigate(`/${eventId}`)
          } else {
            navigate('/auth/memberships')
          }
        })
        .catch((error) => {
          enqueueSnackbar('Información no válida', {variant: 'error'})
          if (error?.detail) setError('afterSubmit', { type: 'custom', message: error?.detail })
        })
    } catch (error) {
      enqueueSnackbar('Algo salio mal, vuelva a intentarlo', {variant: 'error'})
      reset()

      if (isMountedRef.current) {
        setError('afterSubmit', { ...error, message: error?.message ?? '' })
      }
    }
  }

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={3}>
        {!!errors.afterSubmit && <Alert severity="error">{errors.afterSubmit.message}</Alert>}

        <RHFTextField name="email" label="Correo" />

        <RHFTextField
          name="password"
          label="Contraseña"
          type={showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

      {/* <Stack alignItems="flex-end" sx={{ my: 2 }}>
        <Link to={PATH_AUTH.resetPassword} component={RouterLink} variant="body2" color="inherit" underline="always">
          Forgot password?
        </Link>
      </Stack> */}

        <LoadingButton
          fullWidth
          color="inherit"
          size="large"
          type="submit"
          variant="contained"
          loading={isSubmitting}
          sx={{
            bgcolor: 'text.primary',
            color: (theme) => (theme.palette.mode === 'light' ? 'common.white' : 'grey.800'),
            '&:hover': {
              bgcolor: 'text.primary',
              color: (theme) => (theme.palette.mode === 'light' ? 'common.white' : 'grey.800'),
            },
          }}
        >
          Login
        </LoadingButton>
      </Stack>
    </FormProvider>
  );
}
